var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 28.0833C3 14.2302 14.2302 3 28.0833 3C41.9365 3 53.1667 14.2302 53.1667 28.0833C53.1667 41.9365 41.9365 53.1667 28.0833 53.1667C14.2302 53.1667 3 41.9365 3 28.0833ZM28.0833 6.5C16.1632 6.5 6.5 16.1632 6.5 28.0833C6.5 40.0035 16.1632 49.6667 28.0833 49.6667C40.0035 49.6667 49.6667 40.0035 49.6667 28.0833C49.6667 16.1632 40.0035 6.5 28.0833 6.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 28.0833C17 27.1168 17.7835 26.3333 18.75 26.3333H37.4167C38.3832 26.3333 39.1667 27.1168 39.1667 28.0833C39.1667 29.0498 38.3832 29.8333 37.4167 29.8333H18.75C17.7835 29.8333 17 29.0498 17 28.0833Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveOne);
export default __webpack_public_path__ + "static/media/remove-one.03ea5252.svg";
export { ForwardRef as ReactComponent };